import React, { useState } from "react";
import { Select } from "antd";
import { motion, AnimatePresence } from "framer-motion";

const ProfileSettings = () => {
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address: "",
    country: "",
    city: "",
  });

  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setStatus(null);

    try {
      const response = await fetch("/saveShow.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await response.json();

      if (data.status === "success") {
        setStatus({
          type: "success",
          message: "Profile saved successfully",
        });
      } else {
        throw new Error(data.message);
      }
    } catch (err) {
      setStatus({ type: "error", message: err.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <motion.div
      className=" card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Profile Settings
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0 p-4"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >
        {/* BASIC INFO */}
        <motion.div
          className="mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <div className="row g-3">
            {[
              { label: "First Name", name: "first_name" },
              { label: "Last Name", name: "last_name" },
              { label: "Email", name: "email", type: "email" },
              { label: "Phone", name: "phone" },
            ].map((field, i) => (
              <motion.div
                key={field.name}
                className="col-md-6"
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05 }}
              >
                <label className="form-label">{field.label}</label>
                <motion.input
                  whileFocus={{ scale: 1.02 }}
                  type={field.type || "text"}
                  name={field.name}
                  value={form[field.name]}
                  onChange={handleChange}
                  className="form-control"
                  placeholder={field.label}
                />
              </motion.div>
            ))}

            <motion.div
              className="col-12"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              <label className="form-label">Address</label>
              <motion.input
                whileFocus={{ scale: 1.02 }}
                name="address"
                value={form.address}
                onChange={handleChange}
                className="form-control"
                placeholder="Street address"
              />
            </motion.div>
          </div>
        </motion.div>

        {/* LOCATION */}
        <motion.div
          className="mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <h6 className="mb-3">Location</h6>

          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Country</label>
              <Select
                className="w-100"
                placeholder="Select country"
                value={form.country || undefined}
                onChange={(val) =>
                  setForm((prev) => ({ ...prev, country: val }))
                }
              >
                <Select.Option value="India">India</Select.Option>
                <Select.Option value="USA">USA</Select.Option>
              </Select>
            </div>

            <div className="col-md-6">
              <label className="form-label">City</label>
              <Select
                className="w-100"
                placeholder="Select city"
                value={form.city || undefined}
                onChange={(val) =>
                  setForm((prev) => ({ ...prev, city: val }))
                }
              >
                <Select.Option value="Chennai">Chennai</Select.Option>
                <Select.Option value="Mumbai">Mumbai</Select.Option>
              </Select>
            </div>
          </div>
        </motion.div>

        {/* ALERT */}
        <AnimatePresence>
          {status && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              className={`alert ${
                status.type === "success"
                  ? "alert-success"
                  : "alert-danger"
              }`}
            >
              {status.message}
            </motion.div>
          )}
        </AnimatePresence>

        {/* BUTTON */}
        <motion.button
          whileTap={{ scale: 0.95 }}
          className="btn btn-primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Profile"}
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default ProfileSettings;